// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3am8t","content":"LoadingAlert_content__2xNtP"};